import '@nettbureau/theme';
import 'radash';
import { parseFontSize } from '../parsers/font-size.js';
import { parseLineHeight } from '../parsers/line-height.js';
import 'polished';
import { parseTextColor } from '../parsers/text-color.js';
import { parseTextShadow } from '../parsers/text-shadow.js';
import { fontWeight } from '../polyfills/font-weight.js';

/**
 * Generates CSS for applying typography styles to an element.
 *
 * @param options - Options for the mixin.
 */ function typography(options) {
    const { align, color, colorTone = 'medium', fontFamily, italic, lineHeight, shadow, size, strikethrough, verticalAlign, weight } = options;
    return (theme)=>[
            align && {
                textAlign: align
            },
            color && {
                color: parseTextColor(theme, color, colorTone)
            },
            fontFamily && {
                fontFamily: theme.fontFamilies[fontFamily]
            },
            italic && {
                fontStyle: 'italic'
            },
            lineHeight && {
                lineHeight: parseLineHeight(theme, lineHeight)
            },
            strikethrough && {
                textDecoration: 'line-through'
            },
            verticalAlign && {
                verticalAlign
            },
            shadow && {
                textShadow: parseTextShadow(theme, shadow)
            },
            size && {
                fontSize: parseFontSize(theme, size)
            },
            weight && fontWeight(theme.fontWeights[weight])
        ];
}

export { typography };
//# sourceMappingURL=typography.js.map
